// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1rTEE","content":"GlobalSearch_content__3Ruz_"};